import { render, staticRenderFns } from "./RecursiveModelFactorLabel.vue?vue&type=template&id=394ad288&scoped=true&"
import script from "./RecursiveModelFactorLabel.vue?vue&type=script&lang=ts&"
export * from "./RecursiveModelFactorLabel.vue?vue&type=script&lang=ts&"
import style0 from "./RecursiveModelFactorLabel.vue?vue&type=style&index=0&id=394ad288&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "394ad288",
  null
  
)

export default component.exports